/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Welcome_Back_PortfolioInputs */

const en_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Welcome back, ${i?.name}. Here is your portfolio performance.`)
};

const es_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bienvenido de nuevo, ${i?.name}. Este es el rendimiento de tu portafolio.`)
};

const fr_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bon retour, ${i?.name}. Voici les performances de votre portefeuille.`)
};

const de_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Willkommen zurück, ${i?.name}. Hier ist die Performance deines Portfolios.`)
};

const ja_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`おかえりなさい、${i?.name}さん。あなたのポートフォリオのパフォーマンスです。`)
};

const zh_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`欢迎回来，${i?.name}。这是您的产品组合表现。`)
};

const ar_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`مرحباً بعودتك، ${i?.name}. إليك أداء محفظتك.`)
};

const id_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selamat datang kembali, ${i?.name}. Berikut adalah performa portofolio Anda.`)
};

const it_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bentornato, ${i?.name}. Ecco le prestazioni del tuo portafoglio.`)
};

const ru_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`С возвращением, ${i?.name}. Вот эффективность вашего портфеля.`)
};

const pt_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bem-vindo de volta, ${i?.name}. Aqui está o desempenho do seu portfólio.`)
};

const ko_welcome_back_portfolio = /** @type {(inputs: Welcome_Back_PortfolioInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`환영합니다, ${i?.name}님. 귀하의 포트폴리오 성과입니다.`)
};

/**
* | output |
* | --- |
* | "Welcome back, {name}. Here is your portfolio performance." |
*
* @param {Welcome_Back_PortfolioInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const welcome_back_portfolio = /** @type {((inputs: Welcome_Back_PortfolioInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcome_Back_PortfolioInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcome_back_portfolio(inputs)
	if (locale === "es") return es_welcome_back_portfolio(inputs)
	if (locale === "fr") return fr_welcome_back_portfolio(inputs)
	if (locale === "de") return de_welcome_back_portfolio(inputs)
	if (locale === "ja") return ja_welcome_back_portfolio(inputs)
	if (locale === "zh") return zh_welcome_back_portfolio(inputs)
	if (locale === "ar") return ar_welcome_back_portfolio(inputs)
	if (locale === "id") return id_welcome_back_portfolio(inputs)
	if (locale === "it") return it_welcome_back_portfolio(inputs)
	if (locale === "ru") return ru_welcome_back_portfolio(inputs)
	if (locale === "pt") return pt_welcome_back_portfolio(inputs)
	return ko_welcome_back_portfolio(inputs)
});